module.exports = {
    REMINDERS_SETTINGS_RECEIVED: 'REMINDERS_SETTINGS_RECEIVED',
    REMINDERS_SETTINGS_SAVE: 'REMINDERS_SETTINGS_SAVE',
};
